<template>
    <div  class="home-notice" >


 
 <div class="noticejpg" @click="gotonoticeboard">
   <img style="width:100%;height: 100%;" src="https://oss.ansongqiubo.com/assets/lznoticebk.png" alt="">
    
 </div>

<div class="close">
  <img @click="close"
          class="icon2"
          referrerpolicy="no-referrer"
         src="https://oss.ansongqiubo.com/assets/cuo.png" alt=""
        />
</div>


    </div>


</template>

<script>

export default {
  
    data() {
        return {
            showcenter:true
         
        }
    },
    methods: {
     close(){
         
         console.log("close 点击")
          this.$emit('closenotice',false)


     },
     gotonoticeboard(){

         console.log("close 点击公告跳转")
   this.$emit('gotonoticeboard',false)

     }
     
    },
    computed: {
        
    },
}
</script>

<style scoped>
    .home-notice{
       width: 274.5px;
      height: 143.5px;
      background: #FFFFFF;
      box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.3);
      border-radius: 12px;
      position: absolute;
      top: 40%;
      left: 50%;
      margin-top: 100rpx;
      margin-left: -267px;
      z-index: 10;
      padding: 0px;
     

     
    }
   .noticejpg{
     width: 274.5px;
      height: 143.5px;
      z-index: 11;
      position: absolute;
   }
   .close{

      width: 23px;
      height: 23px;
     
      margin-top: 0px;
        z-index: 12;
         position: absolute;
   }
  .closenotic{
      width: 23px;
      height: 23px;
      
  }
  .icon2 {
      width: 28px;
      height: 28px;
      margin-left: 240px;
    }

.nocenter{
 width: 198px;
 height: 48px;
background: #333333;

}

    .gomggaomin{
 
 top: 40%;
left: 50%;
  width: 198px;
   height: 48px;


  } 
</style>
<style>
.denglubutton{
  background-color: rgba(114, 30, 220, 1) !important;
}
</style>


// WEBPACK FOOTER //
// src/component/Noticeboard.vue